import axios from './axios'

export const fetch_advertisings = async (filter, limit, skip, orderBy) => {
  try {
    var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/advertisings`

    if(filter || limit || skip)
      url += `?`
    if(filter){
      for (const key in filter) {
        url += `&filter=AND(${key}:${filter[key]})`
      }
    }

    if(skip)
      url += `&skip=${skip}`
    if(limit)
      url += `&limit=${limit}`
    if(orderBy)
      url += `&orderBy=${orderBy}`

    const config = {
      method: 'get',
      url: url,
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const result = await axios(config)
    return result.data
  } catch (error) {
    return { success: false, message: error }
  }
}

export const fetch_advertising = async (id) => {
  try {
    const config = {
      method: 'get',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/advertisings/${id}`,
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const result = await axios(config)
    return {success: true, data: result.data?.data}
  } catch (error) {
    return { success: false, message: error }
  }
}

export const insert_advertising = async (advertising) => {
  try {
    const data = JSON.stringify(advertising)

    const config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/advertisings`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    }

    const result = await axios(config)
    return result.data
  } catch (error) {
    return { success: false, message: error }
  }
}

export const update_advertising = async (id, advertising) => {
  try {
    const data = JSON.stringify(advertising)

    const config = {
      method: 'patch',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/advertisings/${id}`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    }

    const result = await axios(config)
    return result.data
  } catch (error) {
    return { success: false, message: error }
  }
}

export const delete_advertising = async (id) => {
  try {
    const config = {
      method: 'delete',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/advertisings/${id}`,
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const result = await axios(config)
    return result.data
  } catch (error) {
    return { success: false, message: error }
  }
}

export const upload_advertising_banner = async (id, file) => {
  try{
    let formData = new FormData();
    formData.append("file", file);

    var config = {
      method: 'post',
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/advertisings/${id}/upload`,
      headers: { 
        "Content-Type": "multipart/form-data"
      },
      data : formData
    };
    var result = await axios(config)
    return result.data
  }
  catch(error) {
    return {success: false, message: error}
  }
}